<template>
  <div class="cargoItemWidth">
    <div v-show="showOtherCar" class="clear" style="padding: 10px 0">
      <div class="phbtn">General Cargo</div>
      <div class="otherBtn" @click="showOtherCar = false">Others</div>
    </div>
    <div v-show="!showOtherCar">
      <div class="cargoItem">
        <el-checkbox-group v-model="chkSpecialCar">
          <el-checkbox
            v-for="item in typeGoodsItem"
            :label="item.Id"
            :key="item.Id"
            @change="changeItem(item.Id)"
            v-if="item.Id != generalCargoID && item.Id != woodenCargoID"
            :class="{ bold: item.fontBold }"
          >
            <!-- 普货不显示，FBA普货Id=181, 快递普货Id=139 -->
            <div class="hint">
              {{ item.AttrVal_ContentEn }}
              <div class="tipBox" v-if="item.RemarkEn" style="left: -10px">
                <i></i>
                <p>{{ item.RemarkEn }}</p>
              </div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="margin-bottom: 5px">
        <label
          role="checkbox"
          class="el-checkbox fontZero"
          :class="{ 'is-checked': showNormalGoods === true }"
          aria-checked="true"
        >
          <span
            aria-checked="mixed"
            class="el-checkbox__input"
            :class="{ 'is-checked': showNormalGoods === true }"
          >
            <span class="el-checkbox__inner"></span>
            <input
              type="checkbox"
              aria-hidden="true"
              class="el-checkbox__original"
              value=""
              @change="NormalGoods(true)"
            />
          </span>
          <span class="el-checkbox__label verMid label_txt">
            <span class="font12"
              >My goods do not contain any of the above mentioned goods</span
            >
          </span>
        </label>
      </div>
      <div style="margin-bottom: 8px">
        <label
          role="checkbox"
          class="el-checkbox fontZero"
          :class="{ 'is-checked': showNormalGoods === false }"
          aria-checked="true"
        >
          <span
            aria-checked="mixed"
            class="el-checkbox__input"
            :class="{ 'is-checked': showNormalGoods === false }"
          >
            <span class="el-checkbox__inner"></span>
            <input
              type="checkbox"
              aria-hidden="true"
              class="el-checkbox__original"
              value=""
              @change="NormalGoods(false)"
            />
          </span>
          <span class="el-checkbox__label verMid label_txt">
            <span class="font12"
              >My goods will not contain any of the above goods each time</span
            >
          </span>
        </label>
      </div>
      <!-- <p style="margin:5px 0;"><el-checkbox v-model="chkGenCargo"  class="Dlist"  style="margin-right:10px;" @change="chkGeneral(chkGenCargo)">My shipment does not contain any of the goods listed above</el-checkbox></p> -->
      <div v-if="topUrl !== '/front/express'">
        <span class="colRed"
          ><i class="fa fa-tips marR5" style="margin-top: -2px"></i>Rejected goods: all
          contain liquid, powder, imitation brand, famous brand, paste and other
          items.</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
//引入axios
import { fetch, post } from "../../../ask/axios";
import bus from "@/ask/eventBus";
import { getCookie } from "@/ask/cookiejs";

const cargoItemOptions = [];
export default {
  props: {
    //      titNames:'',
    //      titUrls:''
    // cargoData: {},
  },
  data() {
    return {
      api: {
        url: "",
        param: "",
        response: {},
        message: "",
      },
      typeCargoItem: "", //选中的值
      //generalCargo:true, //是否选中普货值
      //货物种类
      chkSpecialCar: [],
      chkSpecialCarInfos: [], //货物种类名称存值
      typeGoodsItem: cargoItemOptions,

      isTrueBox: false, //是否显示特殊货物下拉框
      topUrl: "", //地址栏地址变量
      generalCargoID: null, //普货ID
      porCargoID: null, //移动电源ID
      batteryCargoID: null, //纯电池ID
      woodenCargoID: null,

      OrdCargo: null,
      chkd: false,

      chkGenCargo: false, //普货

      //普货相关
      showNormalGoods: null,
      showOtherCar: false,
    };
  },

  created() {
    this.topUrl = this.$route.path; //获取当前页面地址栏的url ? 前面的值
    this.getTypeCargo();

    if (
      this.topUrl == "/checkList/quotes" ||
      this.topUrl == "/front/express" ||
      this.topUrl == "/"
    ) {
      this.generalCargoID = 139;
      this.porCargoID = 111;
      this.batteryCargoID = 103;
      this.woodenCargoID = 107;
    } else if (this.topUrl == "/fba/list") {
      this.generalCargoID = 181;
    }
    if (JSON.stringify(this.$route.query) != "{}") {
      let cargoInfo = JSON.parse(this.$route.query.cargoInfoObj);
      this.chkSpecialCar = cargoInfo.cargoID;
      if (this.$route.query.isNormalGood !== null) {
        if (this.$route.query.isNormalGood == "true") {
          this.showNormalGoods = true;
        } else {
          this.showNormalGoods = false;
        }
      }
    }
  },

  mounted() {
    // 事件中心响应编辑订单的事件
    bus.$on("getGeneral", () => {
      this.expShowPu();
    });
    // console.log(this.$route.query, "this.$route.query");
  },

  computed: {
    toBreakWord() {},
  },

  methods: {
    //普货相关
    expShowPu() {
      if (getCookie("En-Generalcargo")) {
        let Flag = JSON.parse(getCookie("En-Generalcargo"))[0] === 1;
        if (Flag) {
          this.chkSpecialCar = [this.generalCargoID];
          this.showNormalGoods = false;
          this.chkGenCargo = true;
          this.showOtherCar = false;
          let cargoInfo = {
            cargoID: this.chkSpecialCar,
            cargoInfoEn: ["General Cargo (Non-Hazardous)"],
            carInfoCh: ["普货"],
          };
          this.$emit("byCargo", cargoInfo, this.showNormalGoods);
        }
      }
    },
    // 普货相关
    NormalGoods(bool) {
      if (this.showNormalGoods === bool) {
        this.showNormalGoods = null;
        this.chkSpecialCar = [];
        this.chkGenCargo = false;
        this.chkGeneral();
        return false;
      }
      this.showNormalGoods = bool;
      this.chkGenCargo = true;
      this.chkGeneral();
    },
    //货物种类接口
    getTypeCargo() {
      this.api.param = {};
      if (
        this.topUrl == "/checkList/quotes" ||
        this.topUrl == "/front/express" ||
        this.topUrl == "/"
      ) {
        this.api.param["AttrMain_Code"] = "KDSpecial";
      }

      // this.api.url = this.$api01 + "/api/Attribute/QueryList";
      this.api.url = this.$api04 + "/Basics/api/Attribute/QueryList";
      post(this.api.url, this.api.param).then((res) => {
        if (
          this.topUrl == "/checkList/quotes" ||
          this.topUrl == "/front/express" ||
          this.topUrl == "/"
        ) {
          let valList = res.Results[0].valList;
          
          valList.forEach(item => {
              this.$set(item, 'Id', item.AttrVal_ID);
            })
          valList = valList.filter((item) => {
            return item.AttrVal_ContentEn; //筛选数据
          });
          //this.typeGoodsItem = valList;
          if (valList) {
            //防疫物资货物种类某些不显示 //筛选出来
            this.typeGoodsItem = [];
            valList.forEach((e) => {
              if (sysCfg.epm.indexOf(e.AttrVal_Code) == -1) {
                this.typeGoodsItem.push(e);
              }
            });
          }

          this.expShowPu();
        }
        //that.getTopAddressVal();
      });
    },
    //选择普货
    chkGeneral() {
      if (!this.chkGenCargo) {
        this.chkSpecialCar = [];
      } else {
        this.chkSpecialCar = [this.generalCargoID];
      }

      var carInfo = [];
      var carInfoCh = [];
      for (var i = 0; i < this.chkSpecialCar.length; i++) {
        let carIndex = this.chkSpecialCar[i];
        this.typeGoodsItem.forEach((e) => {
          if (e.Id == carIndex) {
            carInfo.push(e.AttrVal_ContentEn);
            carInfoCh.push(e.AttrVal_Content);
          }
        });
      }

      let cargoInfo = {
        cargoID: this.chkSpecialCar,
        cargoInfoEn: carInfo,
        carInfoCh: carInfoCh,
      };
      // showNormalGoods 为false 是选了每次
      this.$emit("byCargo", cargoInfo, this.showNormalGoods);
      //console.log('普货选择：' + JSON.stringify(cargoInfo))
    },

    changeItem(value) {
      this.showNormalGoods = null;
      if (value) {
        this.chkGenCargo = false;
      }
      if ($.inArray(value, this.chkSpecialCar) >= 0) {
        if (value == this.generalCargoID) {
          //是否勾选了普货
          this.chkSpecialCar = [value];
        } else {
          //勾选中不是普货
          this.arrRemove(this.generalCargoID, this.chkSpecialCar);
        }
      }
      if ($.inArray(value, this.chkSpecialCar) >= 0) {
        if (value == this.porCargoID) {
          //是否勾选了移动电源
          this.chkSpecialCar = [value];
        } else {
          //勾选中不是移动电源
          this.arrRemove(this.porCargoID, this.chkSpecialCar);
        }
      }

      if ($.inArray(value, this.chkSpecialCar) >= 0) {
        if (value == this.batteryCargoID) {
          //是否勾选了纯电池
          this.chkSpecialCar = [value];
        } else {
          //勾选中不是纯电池
          this.arrRemove(this.batteryCargoID, this.chkSpecialCar);
        }
      }

      //获取货物种类英文名称
      //chkSpecialCarInfos
      var carInfo = [];
      var carInfoCh = [];
      for (var i = 0; i < this.chkSpecialCar.length; i++) {
        let carIndex = this.chkSpecialCar[i];
        this.typeGoodsItem.forEach((e) => {
          if (e.Id == carIndex) {
            carInfo.push(e.AttrVal_ContentEn);
            carInfoCh.push(e.AttrVal_Content);
          }
        });
      }
      let cargoInfo = {
        cargoID: this.chkSpecialCar,
        cargoInfoEn: carInfo,
        carInfoCh: carInfoCh,
      };

      this.$emit("byCargo", cargoInfo, this.showNormalGoods);

      //console.log('11sss11：' +  JSON.stringify(cargoInfo))
    },
    //js给根据数组元素删除数组中指定元素,不是根据索引
    arrRemove(val, arr1) {
      var index = $.inArray(val, arr1);
      if (index > -1) {
        arr1.splice(index, 1);
      }
    },
  },
};
</script>
<style lang="css" scoped>
/*---------------------------------- 货物种类 样式  -------------------------*/
.cargoItemWidth {
  padding: 8px 20px;
}
.cargoItem label {
  width: 280px;
  margin: 5px 0;
}
.label_txt {
  font-weight: bold;
  color: #555;
}
.hint {
  position: relative;
  font-size: 13px !important;
}
.hint:hover div {
  display: block;
}

.tipBox {
  display: none;
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  left: -32px;
  top: 30px;
  background: #fff;
  z-index: 999;
  width: 250px;
  border: 1px solid #ddd;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
}
.tipBox p {
  margin: 0;
  padding: 0;
  line-height: 20px;
  color: #888;
  font-size: 13px;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-wrap;
}
.tipBox p em {
  font-style: normal;
}
.tipBox i {
  background: url(../../../assets/img/arrow-icon-s.png) no-repeat;
  width: 22px;
  height: 12px;
  display: block;
  position: absolute;
  top: -12px;
  left: 11%;
  z-index: 9999;
}
.Dlist {
  font-weight: bold;
  color: black;
}
.phbtn {
  float: left;
  height: 22px;
  background: #004fb1;
  color: white;
  border: 1px solid #004fb1;
  line-height: 22px;
  text-align: center;
  border-radius: 30px;
  cursor: pointer;
  padding: 0 10px;
}
.otherBtn {
  line-height: 24px;
  font-size: 12px;
  color: #004fb1;
  text-align: center;
  float: left;
  width: 70px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/userCenter/public/typeCargo.vue